import React, { useMemo } from 'react'
import { FilterOption } from 'types/filters'
import dynamic from 'next/dynamic'
import styles from './styles.module.scss'

const EvenSizesNote = dynamic(() => import('./Notes/EvenSizesNote'))
const TopsPlusNote = dynamic(() => import('./Notes/TopsPlusNote'))
const TopsDadleticNote = dynamic(() => import('./Notes/TopsDadleticNote'))
const SweatShirtsStraightNote = dynamic(
  () => import('./Notes/SweatShirtsStraightNote')
)

const EVEN_SIZES_PRODUCT_TYPES = [
  'House Trouser',
  'House Shorts',
  'Lightweight House Trouser'
]

type SizeHelperProps = {
  selectedOptions: FilterOption[]
  productType: string
  values: string[]
  type: string
}

function getMatchingSelectedOptionValue(
  selectedOptions: FilterOption[],
  type: string
) {
  return (
    (selectedOptions.find(option => option.type === type) || {}).value || ''
  )
}

function SizeHelper({
  selectedOptions = [],
  productType,
  values = [],
  type
}: SizeHelperProps) {
  const isEvenSizes =
    values.every(value => !(Number(value) % 2)) &&
    type === 'waist' &&
    EVEN_SIZES_PRODUCT_TYPES.includes(productType)

  const isSelectedOptionTopsPlusSize = /\+/g.test(
    getMatchingSelectedOptionValue(selectedOptions, type)
  )

  const isSelectedOptionTopsDadleticSize = /\Dadletic/g.test(
    getMatchingSelectedOptionValue(selectedOptions, type)
  )

  const isSelectedOptionSweatshirtsStraight =
    /Straight/.test(getMatchingSelectedOptionValue(selectedOptions, type)) &&
    type === 'cut' &&
    productType.includes('Sweatshirts')

  const currentLegValue = selectedOptions.find(option => {
    return option.type === 'leg'
  })?.value

  const SizeHelperComponent = useMemo(() => {
    if (isEvenSizes) return EvenSizesNote

    if (isSelectedOptionTopsPlusSize) return TopsPlusNote

    if (isSelectedOptionTopsDadleticSize) return TopsDadleticNote

    if (isSelectedOptionSweatshirtsStraight) return SweatShirtsStraightNote

    return null
  }, [
    isEvenSizes,
    isSelectedOptionTopsPlusSize,
    isSelectedOptionTopsDadleticSize,
    isSelectedOptionSweatshirtsStraight
  ])

  return (
    <div
      className={`${styles.sizeHelper} ${
        !!SizeHelperComponent ? styles.open : ''
      }`}
    >
      {!!SizeHelperComponent && (
        <SizeHelperComponent
          selectedOptions={selectedOptions}
          productType={productType}
          type={type}
        />
      )}
    </div>
  )
}

export default SizeHelper
